module.exports = __webpack_public_path__ + "img/verify8.a390f6ce.png";